import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n';

export const PasswordCheckRow = ({ validation, messsage }) => {
  return (
    <li className={`${validation && 'checked'}`}>
      <i className={`ic-task-check sm ${validation && 'selected'}`} />
      <span className="text">{i18n.t(messsage)}</span>
    </li>
  );
};
PasswordCheckRow.propTypes = { validation: PropTypes.bool, messsage: PropTypes.string.isRequired };
PasswordCheckRow.defaultProps = { validation: false };
export default PasswordCheckRow;
